<template>
  <v-dialog v-model="dialog" width="480" persistent>
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        <v-icon color="grey" class="mr-2">mdi-printer-settings</v-icon>
        Configurazione
        <span class="ml-2 green--text font-weight-bold">{{ stampante.device_id }}</span>
        <v-spacer />
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-row>
          <v-col cols="6">
            <v-select
              v-model="form.mode"
              :items="mode_items"
              label="Modo"
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="form.orientation"
              :items="orientation_items"
              label="Orientamento"
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>

        <v-sheet outlined rounded class="pa-3 mt-3">
          <div class="text-caption green--text mb-2">Velocità</div>
          <div class="text-caption grey--text mb-1">Stampa: {{ form.velocity }} ips</div>
          <v-slider
            v-model="form.velocity"
            :min="1"
            :max="8"
            :step="1"
            thumb-label
            color="green"
            track-color="grey lighten-2"
            hide-details
            class="mb-2"
          />
          <div class="text-caption grey--text mb-1">Slew: {{ form.slew_speed }} ips</div>
          <v-slider
            v-model="form.slew_speed"
            :min="2"
            :max="14"
            :step="1"
            thumb-label
            color="green"
            track-color="grey lighten-2"
            hide-details
            class="mb-2"
          />
          <div class="text-caption grey--text mb-1">Backfeed: {{ form.backfeed_speed }} ips</div>
          <v-slider
            v-model="form.backfeed_speed"
            :min="2"
            :max="14"
            :step="1"
            thumb-label
            color="green"
            track-color="grey lighten-2"
            hide-details
          />
        </v-sheet>

        <v-row class="mt-3">
          <v-col cols="12">
            <div class="text-caption grey--text mb-1">Scurezza: {{ form.darkness }}</div>
            <v-slider
              v-model="form.darkness"
              :min="-10"
              :max="10"
              :step="1"
              thumb-label
              color="green"
              track-color="grey lighten-2"
              hide-details
            />
          </v-col>
        </v-row>

        <v-row class="mt-3">
          <v-col cols="6">
            <v-text-field
              v-model.number="form.offset_x"
              label="Offset X"
              type="number"
              outlined
              dense
              hide-details
              prepend-inner-icon="mdi-arrow-left-right"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="form.offset_y"
              label="Offset Y"
              type="number"
              outlined
              dense
              hide-details
              prepend-inner-icon="mdi-arrow-up-down"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-expand-x-transition>
          <v-icon color="success" class="mr-3" v-if="save_ok">mdi-check</v-icon>
        </v-expand-x-transition>
        <v-btn text color="grey" @click="close">Annulla</v-btn>
        <v-btn outlined color="green" :loading="saving" @click="salva">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfigStampanteDialog",
  data: () => ({
    dialog: false,
    saving: false,
    save_ok: false,
    stampante: {},
    form: {
      mode: "R",
      velocity: 4,
      darkness: 4,
      orientation: "I",
      offset_x: 0,
      offset_y: 0,
      slew_speed: 4,
      backfeed_speed: 4,
    },
    mode_items: [
      { text: "Riavvolgi (R)", value: "R" },
      { text: "Spellicola (P)", value: "P" },

    ],
    orientation_items: [
      { text: "Normale (N)", value: "N" },
      { text: "Invertita (I)", value: "I" },
    ],
  }),
  methods: {
    open(stampante) {
      this.stampante = stampante;
      this.form = {
        mode: stampante.mode ?? "R",
        velocity: stampante.velocity ?? 4,
        darkness: stampante.darkness ?? 4,
        orientation: stampante.orientation ?? "I",
        offset_x: stampante.offset_x ?? 0,
        offset_y: stampante.offset_y ?? 0,
        slew_speed: stampante.slew_speed ?? 4,
        backfeed_speed: stampante.backfeed_speed ?? 4,
      };
      this.save_ok = false;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    salva() {
      this.saving = true;
      this.$store
        .dispatch("patch_stampante", {
          id_device: this.stampante.device_id,
          params: { ...this.form },
        })
        .then(() => {
          this.save_ok = true;
          setTimeout(() => {
            this.save_ok = false;
            this.close();
          }, 1200);
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
